<template>
  <div class="page500">500</div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'page500'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/errorPages/page500.vue